import { render, staticRenderFns } from "./create-issue.vue?vue&type=template&id=1815eb6a&scoped=true"
import script from "./create-issue.vue?vue&type=script&lang=js"
export * from "./create-issue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1815eb6a",
  null
  
)

export default component.exports